export const asciiLogo = `  _____  _______ _______  _____  _______ __   __ _______
 |     | |______ |  |  | |     | |______   \\_/   |______
 |_____| ______| |  |  | |_____| \\______|    |    ______|`;
